import Model, { belongsTo, hasMany } from '@ember-data/model';

export default class EntityDetailModel extends Model {
  @belongsTo('organization/entity', { async: false, inverse: null })
  entity: any;
  @hasMany('organization/line-item', { async: true, inverse: null })
  lineItems: any;
  @hasMany('organization/pledge', { async: true, inverse: null })
  pledges: any;
}
